var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg90Opt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 -0.5 17 17",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    transform: "translate(-0.5,0.522)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.838 2.344v5.312h-4.002a1.31 1.31 135 0 0-1.31 1.311v4.002H4.213v-4.91a5.705 5.705 134.943 0 1 5.694-5.705z",
    style: {
      fill: "#000000",
      strokeWidth: 0.06375,
      stroke: "none",
      strokeOpacity: 1,
      strokeDasharray: "none",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg90Opt);
export default __webpack_public_path__ + "static/media/90_opt.1abab1924b7f6ff92f1c8822bbda12d5.svg";
export { ForwardRef as ReactComponent };